import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataStorageService {

  constructor() { }

  getLocalStorageByName(name : string): any{
    return localStorage.getItem(name);
  }

  setLocalStorageByName(name : string, user : any){
    localStorage.setItem(name, JSON.stringify(user));
  }

  setLocalStorageByValue(name : string, data : any){
    localStorage.setItem(name, data);
  }

  removeItemFromLocalStorage(name: string){
    localStorage.removeItem(name);
  }

  clearLocalStorage() {
    localStorage.clear();
  }
}
